<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'app'
};

</script>

<style>

html, body {
    margin: 0;
    padding: 0;
    background-color: #000;
    width: 100%;
    height: 100%;
}

#app {
	height: 100%;
}
  
</style>



// WEBPACK FOOTER //
// App.vue?62b621a5